import * as React from 'react';
import styled, { css } from 'styled-components';
import { Text } from '@amzn/storm-ui';
import { AccountLabel } from './AccountLabel';
import { Account } from '@amzn/aac-chrome-internal-api';
import { getTaktAttributes } from 'src/commons/utils/logWithTakt';
import { chromeComponents } from 'src/constants';

const contentsContainerMixin = css`
  &&& {
    text-decoration: none;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: ${({ theme }) =>
      `${theme.spacing.xxxsmall.default} ${theme.spacing.base.default}`};
    outline: revert;
    text-align: start;
    min-height: 40px;
  }
`;

export const AdvertisingAccountLink = styled.a`
  ${contentsContainerMixin};
`;

export const AdvertisingAccountContainer = styled.div`
  ${contentsContainerMixin};
`;

export const AdvertisingAccountMarketplaceName = styled(Text)`
  color: ${({ theme }) => theme.text.color.tertiary};
`;

export const RetailerName = styled(Text)`
  color: ${({ theme }) => theme.text.color.secondary};
`;

type AdvertisingAccountContentType = {
  label: string;
  countryLabel: string;
  retailerName?: string;
};

const AdvertisingAccountContent: React.FC<AdvertisingAccountContentType> = ({
  label,
  countryLabel,
  retailerName,
}) => {
  return (
    <span>
      <AccountLabel label={label} />
      {retailerName && (
        <RetailerName size="xsmall">{retailerName}</RetailerName>
      )}
      {countryLabel && (
        <AdvertisingAccountMarketplaceName size="xsmall">
          {countryLabel}
        </AdvertisingAccountMarketplaceName>
      )}
    </span>
  );
};

export const IA2AdvertisingAccountItem: React.FC<{
  advertisingAccount: Account;
  countryLabel: string;
  isSelected: boolean;
  retailerName?: string;
}> = ({ advertisingAccount, countryLabel, isSelected, retailerName }) => {
  const { label, url } = advertisingAccount;

  const contents = (
    <AdvertisingAccountContent
      label={label}
      countryLabel={countryLabel}
      retailerName={retailerName}
    />
  );
  if (isSelected) {
    return (
      <AdvertisingAccountContainer>{contents}</AdvertisingAccountContainer>
    );
  }

  return (
    <AdvertisingAccountLink
      data-ccx-e2e-id="aac-account-link"
      href={url}
      draggable="false"
      {...getTaktAttributes('aac-account-link', chromeComponents.HEADER, {
        url,
        label,
        ...(retailerName && { retailerName }),
      })}
    >
      {contents}
    </AdvertisingAccountLink>
  );
};
